var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_1162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0C93.1394 0 120 26.8606 120 60C120 93.1394 93.1394 120 60 120C26.8606 120 0 93.1394 0 60C0 26.8606 26.8606 0 60 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.976 60L33.0192 75.8654L46.5 83.7981V93.0866L25.1298 80.5529V55.3606L32.976 60ZM32.976 44.1347V53.3798L25.125 48.7356V39.4904L32.976 34.8462L40.8654 39.4904L32.976 44.1347ZM52.1298 39.4904L59.9808 34.8462L67.8702 39.4904L59.9808 44.1347L52.1298 39.4904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6484 72.577V63.2885L46.4994 67.9327V77.1779L38.6484 72.577ZM52.1292 87.125L59.9802 91.7693L67.8696 87.125V96.3702L59.9802 101.014L52.1292 96.3702V87.125ZM79.1292 39.4904L86.9802 34.8462L94.8696 39.4904V48.7356L86.9802 53.3798V44.1347L79.1292 39.4904ZM86.9802 75.8654L87.0234 60L94.8744 55.3558V80.5481L73.5042 93.0818V83.7933L86.9802 75.8654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.351 72.577L73.5 77.178V67.9328L81.351 63.2886V72.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3504 47.4229L81.3936 56.7113L67.8744 64.644V80.5479L60.0234 85.1488L52.1725 80.5479V64.644L38.6532 56.7113V47.4229L46.5379 42.7786L59.9754 50.7498L73.4946 42.7786L81.384 47.4229H81.3504ZM38.6484 31.5623L59.9802 18.9854L81.3504 31.5623L73.4994 36.2065L59.9802 28.2354L46.4994 36.2065L38.6484 31.5623Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.1b850d1e.svg";
export { ForwardRef as ReactComponent };